import { render, staticRenderFns } from "./ProductsVariationForm.vue?vue&type=template&id=a480c23c&"
import script from "./ProductsVariationForm.vue?vue&type=script&lang=js&"
export * from "./ProductsVariationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports